import script from "./service.vue?vue&type=script&setup=true&lang=js"
export * from "./service.vue?vue&type=script&setup=true&lang=js"

import "./service.vue?vue&type=style&index=0&id=3f2a5ca4&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2a5ca4"]])

export default __exports__